import { ProductsPage } from '../components/pages'

export default ProductsPage
